export default __webpack_public_path__ + "static/media/skalamand.1c8243b0.png";